module.exports = __webpack_public_path__ + "img/release.373d284a.png";